import { useMatches } from 'react-router-dom';

import { RouteId } from './routes';

export const useRouteId = (): RouteId => {
    const matches = useMatches();
    const { id } = matches.slice(-1)[0];
    return id as RouteId;
};
